import React, { Component, PropTypes } from 'react';
import Cropper from 'react-cropper';
import FileSelector from 'common/components/file_selector';

/*
 * A component that wraps the File Selector and Cropper components and has
 * fully controlled props.  See props below for more details.
 */
export default class ImageUpload extends Component {

  constructor(props) {
    super(props);
    this.readFile = this.readFile.bind(this);
    this.cropImage = this.cropImage.bind(this);
  }

  readFile(file) {
    if (!window.FileReader) {
      return;
    }

    const { selectImage, onDone, onCrop } = this.props;
    const reader = new window.FileReader();
    reader.onloadend = () => {
      // update result and call onDone() if no cropping is needed
      selectImage(reader.result);
      if (!onCrop) {
        onDone();
      }
    };
    reader.readAsDataURL(file);
  }

  cropImage(event) {
    event.preventDefault();
    if (typeof this.cropper.getCroppedCanvas() === 'undefined' || !window.FileReader) {
      return;
    }

    // update the cropped image and call onDone() if cropped image
    // meets min width and height requirements
    const { onCrop, onDone, minWidth, minHeight } = this.props;
    const cropped = this.cropper.getCroppedCanvas();

    onCrop(cropped.toDataURL());
    onDone();
  }

  render() {
    const { minWidth, minHeight, preCrop, maxSize, cropperRatio=1 } = this.props;

    return (
      <div className="image-upload">
        {!preCrop && <FileSelector
          minImageWidth={minWidth}
          minImageHeight={minHeight}
          maxSize={maxSize}
          onValidFileSelected={this.readFile}
        />}
        {preCrop && <div className="crop-image">
          <Cropper
            ref={(c) => { this.cropper = c; }}
            src={preCrop}
            minCropBoxWidth={minWidth}
            minCropBoxHeight={minHeight}
            aspectRatio={cropperRatio}
            style={{ height: '100%', width: '100%' }}
            guides={false}
          />
          <button type="button" className="btn btn-tertiary btn-block file-done"
              onClick={this.cropImage}>
            Done
          </button>
        </div> }
      </div>
    );
  }
}

/**
 * @property {number} minWidth - minimum width of selected/cropped image
 * @property {number} minHeight - minimum height of selected/cropped image
 * @property {number} maxSize - maximum file size in MB
 * @property {func} selectImage - required - triggered when image is selected by file
 *
 * @property {func} onCrop - triggered when image is successfully cropped.  If not set,
 *                           onDone will be called immediately after selectImage is.
 * @property {func} onDone - triggered when image is ready to be used.
 * @property {string} preCrop - should data uri string for selected image, must be provided
 *                              when image must be cropped. If set, cropper will be displayed
 *                              instead of file selector.
 *
 */

ImageUpload.propTypes = {
  selectImage: PropTypes.func.isRequired,
  onCrop: PropTypes.func,
  onDone: PropTypes.func,
  preCrop: PropTypes.string,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  maxSize: PropTypes.number,
};



// WEBPACK FOOTER //
// ./common/components/image_upload.jsx